import useSWR from 'swr';

import type { ILabelValuePair } from '../../components/marking/MarkingInterfaces';
import { getEnumValues } from '../../components/policyConfigurator/shared/Utilities/PolicyConfiguratorHelpers';
import {
  MARKINGWORKFLOWS, POLICYCONFIGURATORSECTIONS, PRICINGWORKFLOWS, ROUTINGWORKFLOWS,
} from '../../components/policyConfigurator/shared/Utilities/PolicyConfiguratorInterfaces';

const GetRuleOutcomeFields = (workflowName: string, workflowType: POLICYCONFIGURATORSECTIONS | undefined): {
  outcomeFields: ILabelValuePair[] | undefined,
} => {
  const getOutcomeFieldsFromSection = (workflowTypeParam: POLICYCONFIGURATORSECTIONS): ILabelValuePair[] | undefined => {
    switch (workflowTypeParam) {
      case POLICYCONFIGURATORSECTIONS.MARKING: {
        return getEnumValues(MARKINGWORKFLOWS).map((value: string) => ({ label: value, value }));
      }
      case POLICYCONFIGURATORSECTIONS.PRICING: {
        return getEnumValues(PRICINGWORKFLOWS).map((value: string) => ({ label: value, value }));
      }
      case POLICYCONFIGURATORSECTIONS.ROUTING: {
        return getEnumValues(ROUTINGWORKFLOWS).map((value: string) => ({ label: value, value }));
      }
      default: {
        return [{ label: '', value: '' }];
      }
    }
  };

  const fetcher = (workflowParam: string, workflowTypeParam: POLICYCONFIGURATORSECTIONS) => {
    switch (workflowTypeParam) {
      case POLICYCONFIGURATORSECTIONS.MARKING: {
        return [{ label: 'Name', value: 'Name' }, { label: 'Type', value: 'Type' }];
      }
      default: {
        return (workflowParam === '') ? getOutcomeFieldsFromSection(workflowTypeParam) : [{ label: workflowName, value: workflowName }];
      }
    }
  };

  const { data } = useSWR<ILabelValuePair[] | undefined>([workflowName, workflowType],
    (workflowParam, workflowTypeParam) => fetcher(workflowParam, workflowTypeParam));

  return {
    outcomeFields: data,
  };
};

export default GetRuleOutcomeFields;
